import { render, staticRenderFns } from "./NuevoEnvio.vue?vue&type=template&id=39a18854"
import script from "./NuevoEnvio.vue?vue&type=script&lang=js"
export * from "./NuevoEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports